import request from '@/utils/request'

// 获取轮播图列表
export function getBannerList(query) {
  return request({
    url: '/api/v2/banner/list',
    method: 'get',
    params: query
  })
}
